import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "text";

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className"> {
  variant?: Variant;
  wide?: boolean;
  lg?: boolean;
  /** 소형 pill — 전체 동의·처음으로 같은 보조 행동 */
  sm?: boolean;
  icon?: ReactNode;
  className?: string;
}

/** HERIT pill 버튼. primary(딥 그린) · secondary(잉크 아웃라인) · text(밑줄). 크기 lg·sm. */
export function Button({
  variant = "primary",
  wide,
  lg,
  sm,
  icon,
  className,
  children,
  type = "button",
  ...rest
}: Props) {
  const cls = [
    "btn",
    variant === "text" ? "btn--text" : `btn--${variant}`,
    wide ? "btn--wide" : "",
    lg ? "btn--lg" : "",
    sm ? "btn--sm" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button type={type} className={cls} {...rest}>
      {icon}
      {children}
    </button>
  );
}
